import { PaymentSchema, CreditCard, CurrentAccount } from "mock/schemas"

type PaymentSchemaArray = [string, "IBAN" | "CREDIT_CARD", string, CurrentAccount | CreditCard, string];

const paymentArray: PaymentSchemaArray[] = [
    ["1", "IBAN", "Bertrand Martin", { IBAN: "**** **** **** **** **** **** 345", BIC: "ABCD FR ** ***" }, "1"],
    ["2", "CREDIT_CARD", "Béatrice Beauvau", { cardNumber: "**** 3456", expirationDate: "12/26", cvv: "123" }, "2"],
    ["3", "CREDIT_CARD", "Béatrice Beauvau", { cardNumber: "**** 7890", expirationDate: "11/26", cvv: "456" }, "2"],
    ["4", "CREDIT_CARD", "Béatrice Beauvau", { cardNumber: "**** 1234", expirationDate: "10/26", cvv: "789" }, "2"],
    ["5", "CREDIT_CARD", "Béatrice Beauvau", { cardNumber: "**** 3456", expirationDate: "12/26", cvv: "123" }, "2"],

];

const createPaymentObject = (arr: PaymentSchemaArray) : PaymentSchema => {
    return {
        id: arr[0],
        type: arr[1],
        name: arr[2],
        payment_data: arr[3],
        entity_id: arr[4],
    }
}

export const paymentsMockDatas: PaymentSchema[] = paymentArray.map((arr) =>
    createPaymentObject(arr)
)